import { Box, Dialog, DialogContent, DialogTitle, Divider, IconButton, styled, Typography } from '@mui/material';
import { Button, Icon } from 'components';
import React from 'react';

import video from '../../../../../assets/videos/desktopScreenSize.mp4';
import screenZoom from '../../../../../assets/videos/screenZoom.svg';

const Modal = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: `${theme.spacing(2)}  0px`,
    borderBottom: 0
  },
  '& .MuiDialogActions-root': {
    margin: 0
  },
  '& .MuiDialogTitle-root': {
    padding: 0,
    marginBottom: theme.spacing(2)
  }
}));
const ScreenSizeWarning = ({ modalopen, handleModalClose }: { modalopen: boolean; handleModalClose: () => void }) => {
  return (
    <Modal
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: theme => ({ p: theme.spacing(3), borderRadius: 3, minWidth: 570, maxWidth: 570, minHeight: 400 })
      }}
      open={modalopen}
      // onClose={handleModalClose}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleModalClose();
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle fontWeight={600} fontSize={18} id="alert-dialog-title">
        Optimized for monitors
      </DialogTitle>
      <IconButton
        onClick={handleModalClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: 16,
          color: theme => theme.palette.grey[500],
          borderRadius: '4px',
          padding: '0'
        }}
      >
        <Icon name="close" size={'24'} />
      </IconButton>
      <DialogContent dividers>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '24px'
          }}
        >
          <Box
            sx={{
              width: '312px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: '12px'
                }}
              >
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    backgroundColor: 'rgba(0, 0, 0, 0.10)',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Icon name="monitor-linear" size={20} />
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    padding: '6px',
                    backgroundColor: 'rgba(0, 0, 0, 0.10)',
                    borderRadius: '30px'
                  }}
                >
                  Display Tip
                </Typography>
              </Box>

              <Typography variant="caption" sx={{ color: 'rgba(0, 0, 0, 0.7)' }}>
                For screens 15” or smaller, we recommended adjusting your browser zoom to 80% for the best experience{' '}
              </Typography>

              <Divider />

              <Typography variant="caption" sx={{ color: 'rgba(0, 0, 0, 1)' }}>
                Quick Setup
              </Typography>

              <img
                src={screenZoom}
                style={{
                  width: 290,
                  height: 76,
                  objectFit: 'cover'
                }}
              />
            </Box>
            <Button onClick={handleModalClose}>Got it </Button>
          </Box>
          <Box>
            <video
              // controls
              autoPlay
              playsInline
              loop
              muted
              style={{
                width: '100%',
                height: 340,
                minHeight: 340,
                objectFit: 'cover',
                borderRadius: 12
                // marginBottom: 12
              }}
            >
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Box>
        </Box>
      </DialogContent>
    </Modal>
  );
};

export default ScreenSizeWarning;
